module.exports = __webpack_public_path__ + "img/link_white.0cc15b71.png";